module.exports = new __parcel__URL__("plane_3_red.419ba714.png").toString();